import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {RouteService} from '../../shared/services/route.service';
import {Stop} from '../../shared/models/stop.model';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {RouteCreate} from '../../shared/models/route.model';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {RouteGroup} from '../../shared/models/routeGroup.model';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'form-route',
    templateUrl: 'form-route.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormRouteComponent implements OnInit, OnDestroy {
    constructor(
        private routeService: RouteService,
        private dataStorageService: DataStorageService,
        private ngDateParserFormatter: NgbDateParserFormatter) {
    }

    routeForm: FormGroup;
    stops: Stop[];
    routeGroups: RouteGroup[];
    routeGroupOptions: any = [];
    pickStopOptions: any = [];
    dropStopOptions: any = [];

    selectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['label']
    };

    stopSelectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['label']
    };

    pickStopSelectValue: string[] = [''];
    dropStopSelectValue: string[] = [''];
    routeGroupSelectValue: string[] = [''];

    date: { year: number, month: number };

    private unsubscribe$: Subject<void> = new Subject<void>();

    ngOnInit() {

        this.stops = this.routeService.getStop();
        this.routeGroups = this.routeService.getRouteGroup();
        this.initRouteGroupOptions();
        this.initStopOptions();
        this.initForm();

        this.routeService.stopsChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
                (stops: Stop[]) => {
                    this.stops = this.routeService.getStop();
                    this.initStopOptions();
                }
            );

        this.routeService.routeGroupsChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
                (routeGroups: RouteGroup[]) => {
                    this.routeGroups = routeGroups;
                    this.initRouteGroupOptions();
                }
            );

    }

    initForm() {
        this.routeForm = new FormGroup({
            'pick_stop_id': new FormControl(null, Validators.required),
            'drop_stop_id': new FormControl(null, Validators.required),
            'pick_time': new FormControl(null, Validators.required),
            'drop_time': new FormControl(null, Validators.required),
            'start_date': new FormControl(null, Validators.required),
            'end_date': new FormControl(null, Validators.required),
            'adult_price': new FormControl(null, Validators.required),
            'child_price': new FormControl(null, Validators.required),
            'infant_price': new FormControl(null, Validators.required),
            'route_group_id': new FormControl(null, Validators.required)
        });
    }

    initRouteGroupOptions() {
        for ( const routeGroup of this.routeGroups ) {
            this.routeGroupOptions.push({'label': routeGroup.title, 'value': routeGroup.id, 'code': routeGroup.title});
        }
    }

    initStopOptions() {
        for (const stop of this.stops) {
            this.pickStopOptions.push({'label': stop.title, 'value': stop.id, 'code': stop.title});
            this.dropStopOptions.push({'label': stop.title, 'value': stop.id, 'code': stop.title});
        }
    }

    onAddRoute() {
        const value = this.routeForm.value;
        value.start_date = this.ngDateParserFormatter.format(value.start_date);
        value.end_date = this.ngDateParserFormatter.format(value.end_date);
        const newRoute = new RouteCreate(value.pick_stop_id, value.drop_stop_id, value.pick_time, value.drop_time,
            value.start_date, value.end_date, +value.adult_price, +value.child_price, +value.infant_price, value.route_group_id);
        this.dataStorageService.createRoute(newRoute);
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
